import React, { Suspense, type ReactNode } from "react";
import { Loading } from "@/components/ui/loading";

export { useAuth } from "./context";
export type { AuthUser, AuthContextValue } from "./types";

const PROVIDER = import.meta.env.VITE_AUTH_PROVIDER as string | undefined;

if (!PROVIDER || !["dev", "identity_platform", "auth0"].includes(PROVIDER)) {
  throw new Error(
    `VITE_AUTH_PROVIDER must be set to "dev", "identity_platform", or "auth0". Got: "${PROVIDER}"`
  );
}

const LazyProvider = React.lazy(() => {
  if (PROVIDER === "dev") return import("./providers/dev");
  if (PROVIDER === "identity_platform") return import("./providers/firebase");
  return import("./providers/auth0");
});

export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={<Loading />}>
      <LazyProvider>{children}</LazyProvider>
    </Suspense>
  );
}
